import Marionette from "backbone.marionette";
import Validation from "backbone-validation";
import Cleave from "cleave.js";
import $ from "jquery";

import config from "../config";
import template from "../templates/components/account.jst";
import modalTemplate from "../templates/components/modal.jst";
import models from "../models/user";
import util from "../util";

import SetPasswordView from "./password";

util.bindValidation();

const EditAccountView = SetPasswordView.extend({
    template,
    ui: {
        firstName: "#first_name",
        lastName: "#last_name",
        pwResetLink: ".pw-reset",
        pwResetContainer: ".pw-reset-container",
        jobAlertsEnabled: "[name=job_alerts_enabled]",
        form: ".pw-group",
        error: ".pw-group .help-block",
    },
    events: {
        "click .btn-primary": "onSubmit",
        "click @ui.pwResetLink": "onResetPassword",
        "click .ot-sdk-show-settings": "showCookieSettings",
    },
    showCookieSettings() {
        if (window.OneTrust && window.OneTrust.ToggleInfoDisplay) {
            window.OneTrust.ToggleInfoDisplay();
        }
    },
    serializeData() {
        return {
            user: this.options.data.user,
            isAccountSettings: this.options.isAccountSettings,
        };
    },
    isPWReset() {
        return this.pwReset && this.ui.password.val().length > 0;
    },
    getData() {
        const data = this.model.toJSON();
        data.csrf_token = window.csrfToken;

        if (this.isPWReset()) {
            data.password = this.ui.password.val();
        }
        if (this.options.isAccountSettings) {
            data.job_alerts_enabled = this.ui.jobAlertsEnabled.is(":checked");
        }
        if (this.ui.firstName.val()) {
            data.first_name = this.ui.firstName.val();
        }
        if (this.ui.lastName.val()) {
            data.last_name = this.ui.lastName.val();
        }

        return data;
    },
    onResetPassword(event) {
        event.preventDefault();

        this.ui.pwResetLink.fadeOut("fast");
        this.ui.pwResetContainer.fadeIn("fast");
        this.ui.password.val("").prop("disabled", false).focus();

        this.pwReset = true;
    },
    onRender() {
        const { user } = this.options.data;
        this.model = new models.EditUser({
            first_name: user.first_name,
            last_name: user.last_name,
            email: user.email,
            phone: user.phone,
        });

        this.bindUIElements();
        Validation.bind(this);

        /* eslint-disable no-new */
        new Cleave(this.ui.phone, config.cleave.PHONE_CONFIG);
        /* eslint-enable */
    },
    validate() {
        const pwValid = this.isPWReset() ? SetPasswordView.prototype.validate.call(this) : true;

        this.nameChanged = false;

        if (pwValid) {
            const firstName = this.ui.firstName.val();
            const lastName = this.ui.lastName.val();
            const email = this.ui.email.val();
            const phone = this.ui.phone.val();

            if (
                firstName !== this.model.get("first_name") ||
                lastName !== this.model.get("last_name")
            ) {
                this.nameChanged = true;
            }

            const valid = this.model.set(
                {
                    first_name: firstName,
                    last_name: lastName,
                    email,
                    phone,
                },
                { validate: "partial" },
            );

            if (!valid) {
                return false;
            }

            return true;
        }

        return false;
    },
    onSuccess() {
        $.modal.close();
        this.trigger("auth:success");

        if (this.nameChanged) {
            const first = this.model.get("first_name");
            const last = this.model.get("last_name");

            $(".js-user-initials").text(first[0].toUpperCase() + last[0].toUpperCase());
            $(".js-user-fullname").text(`${first} ${last}`);
            $(".js-user-firstname").text(first);
            $(".js-user-lastname").text(last);
        }
    },
    showError(msg, msgLower) {
        SetPasswordView.prototype.showError.call(this, msg, msgLower);

        if (msgLower.indexOf("first name") > -1) {
            // ya, I did
            this.ui.first_name.siblings(".help-block").text(msg);
        }
        if (msgLower.indexOf("last name") > -1) {
            this.ui.last_name.siblings(".help-block").text(msg);
        }
    },
});

const AccountComponent = Marionette.View.extend({
    el: "#edit-account-modal",
    template: modalTemplate,
    ui: {
        content: ".modal-content",
    },
    showError(msg) {
        this.ui.form.addClass("has-error");
        this.ui.error.text(msg);
    },
    serializeData() {
        return (
            this.data || {
                user: {},
            }
        );
    },
    onRender() {
        const self = this;
        $.ajax({
            type: "GET",
            url: "/api/hire/v1/profile/",
            dataType: "json",
            contentType: "application/json",
        })
            .done((data) => {
                self.view = new EditAccountView({
                    el: self.ui.content,
                    data,
                    isAccountSettings: false, // true,
                });
                self.view.render();
            })
            .fail(() => {
                self.ui.content.text(
                    "We were unable to pull up your account info. Please try again",
                );
            });

        this.$el.addClass("modal-full");
        this.$el.modal({
            closeClass: "icon-close",
            closeText: "&times;",
            fadeDuration: 350,
            fadeDelay: 0,
        });
    },
});

export default AccountComponent;
